<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('detailProduitReseauNumerique.ecransAssociesReseau')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns level">
          <form @submit.prevent.stop="filter = filterInput" class="level-left">
            <div class="column is-9">
              <div class="field has-addons">
                <div class="control inputSearch has-icons-left is-clearfix">
                  <b-input :placeholder="$t('catalogue.actions.search')"
                           v-model="filterInput" type="search">
                  </b-input>
                  <b-icon class="icon is-left"
                          icon="magnify"></b-icon>
                </div>
                <p class="control">
                  <button class="button is-primary"
                          type="submit">
                    {{ $t('general.button.search') }}
                  </button>
                </p>
              </div>
            </div>
            <div class="column is-narrow">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            icon="calendar-today"
                            @input="$emit('editDateVisualisation', $event)"
                            v-model="dateVisualisation"
                            :editable="true">
              </b-datepicker>
            </div>
          </form>
          <div class="column is-narrow">
            <exportExcelButton
              :perm="permCatalogue.exporter"
              in-progress/>
          </div>
        </div>
        <v-client-table :data="filteredEcransList"
                        class='mgt-10px column is-12 is-paddingless'
                        :columns="columns"
                        :options="options">
          <div slot="produit.reference" slot-scope="props">
            <router-link-blank
              :to="{ name: 'c.bodac.catalogue-ecranNumerique', params: { id: props.row.produitId }}"
              class="lien"
              :message="props.row.produit.reference">
            </router-link-blank>
          </div>
          <div slot="dateDebut" slot-scope="props">
            {{ props.row.dateDebut | formatDate }}
          </div>
          <div slot="dateFin" slot-scope="props">
            {{ props.row.dateFin | formatDate }}
          </div>
          <div slot="outdoor" slot-scope="props" class="has-text-centered">
            <qd-checkbox :value="props.row.produit.produitEcranNumerique
            ? props.row.produit.produitEcranNumerique.outdoor : false"
                        type="is-default"
                        class="pointer-events-none">
            </qd-checkbox>
          </div>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { INFINITE_DAY } from '@/configuration/general';

export default {
  props: {
    produit: Object,
    dateVisualisation: {
      type: Date,
      required: false,
    },
  },
  components: {
    routerLinkBlank,
    exportExcelButton,
  },
  data() {
    return {
      filter: '',
      ecranList: [],
      filterInput: '',
      permCatalogue: CATALOGUE,
      dateForVisualisation: null,
    };
  },
  computed: {
    columns() {
      return [
        'produit.reference',
        'produit.produitEcranNumerique.format',
        'produit.produitEcranNumerique.materielType',
        'adresse',
        'produit.produitEcranNumerique.adresse.codePostal',
        'produit.produitEcranNumerique.adresse.ville',
        'outdoor',
        'dateDebut',
        'dateFin',
      ];
    },
    options() {
      return {
        headings: {
          'produit.reference': this.$i18n.t('catalogue.table.ecran'),
          'produit.produitEcranNumerique.format': this.$i18n.t('catalogue.table.format'),
          'produit.produitEcranNumerique.materielType': this.$i18n.t('catalogue.table.materiel'),
          adresse: this.$i18n.t('catalogue.table.adresse'),
          'produit.produitEcranNumerique.adresse.codePostal': this.$i18n.t('catalogue.table.codePostal'),
          'produit.produitEcranNumerique.adresse.ville': this.$i18n.t('catalogue.table.ville'),
          dateDebut: this.$i18n.t('catalogue.table.startDate'),
          dateFin: this.$i18n.t('catalogue.table.endDate'),
          supprimer: '',
          outdoor: this.$i18n.t('catalogue.table.outdoor'),
        },
        columnsClasses: {
          adresse: 'ellipsis address',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortIcon: SORT_ICON,
        sortable: [
          'produit.reference',
          'produit.produitEcranNumerique.format',
          'produit.produitEcranNumerique.materielType',
          'adresse',
          'produit.produitEcranNumerique.adresse.codePostal',
          'produit.produitEcranNumerique.adresse.ville',
          'dateDebut',
          'dateFin',
        ],
      };
    },
    filteredEcransList() {
      return this.ecranList.filter(item => {
        const produitSearch = [
          item.produit.produitEcranNumerique.codeEcran,
          item.produit.produitEcranNumerique.format,
          item.produit.produitEcranNumerique.materielType,
          item.produit.produitEcranNumerique.adresse.adresse1,
          item.produit.produitEcranNumerique.adresse.adresse2,
          item.produit.produitEcranNumerique.adresse.adresse3,
          item.produit.produitEcranNumerique.adresse.codePostal,
          item.produit.produitEcranNumerique.adresse.ville,
          item.dateDebut,
          item.dateFin,
        ];
        let find = false;
        const dateFin = item.dateFin ? moment(item.dateFin) : moment(INFINITE_DAY);
        if (!this.dateVisualisation
          || moment(this.dateVisualisation).isBetween(moment(item.dateDebut),
            dateFin, 'day', '[]')) {
          produitSearch.forEach((produitSearch) => {
            if (produitSearch && produitSearch.toLowerCase().includes(this.filter.toLowerCase())) {
              find = true;
            }
          });
        }
        return find;
      });
    },
  },
  mounted() {
    this.dateForVisualisation = this.dateVisualisation;
    this.ecranList = this.produit.produitReseauNumerique.affectationsReseauEcran;
    this.ecranList.forEach(item => {
      this.$set(item, 'adresse', adressFullStringGetter(item.produit.produitEcranNumerique.adresse, true));
    });
    this.ecranList.sort((a, b) => {
      if (a.produit.produitEcranNumerique.adresse.ville
        < b.produit.produitEcranNumerique.adresse.ville) return -1;
      if (a.produit.produitEcranNumerique.adresse.ville
        > b.produit.produitEcranNumerique.adresse.ville) return 1;
      if (a.produit.produitEcranNumerique.adresse.ville
        === b.produit.produitEcranNumerique.adresse.ville) {
        if (a.produit.produitEcranNumerique.codeEcran
          < b.produit.produitEcranNumerique.codeEcran) return -1;
        if (a.produit.produitEcranNumerique.codeEcran
          > b.produit.produitEcranNumerique.codeEcran) return 1;
      }
      return 0;
    });
  },
};

</script>
